import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiDollarSign,FiTrendingDown,FiCheck}=FiIcons;

const RealSavings=()=> {
  const testimonials=[
    {
      business: "Manhattan Restaurant",
      provider: "Spectrum Business",
      oldBill: "$289/month",
      newBill: "$145/month",
      savings: "$144/month",
      quote: "We were paying way above the average internet bill NYC restaurants should expect. The negotiation process was seamless and we kept our same reliable connection."
    },
    {
      business: "Brooklyn Law Firm", 
      provider: "Verizon Business",
      oldBill: "$456/month",
      newBill: "$267/month",
      savings: "$189/month",
      quote: "Learning how to negotiate internet bill terms seemed daunting, but they handled everything. Our NYC business internet service is now much more affordable."
    },
    {
      business: "Hudson Valley Medical Office",
      provider: "Comcast Business", 
      oldBill: "$234/month",
      newBill: "$156/month",
      savings: "$78/month",
      quote: "Their lower internet bill consultation delivered exactly what they promised - real savings on our Manhattan business internet costs."
    }
  ];

  const benefits=[
    "No service interruption during NYC business internet negotiation",
    "Keep your current internet speed and reliability", 
    "Direct relationships with Manhattan business internet provider reps",
    "100% confidential and secure process",
    "Learn how to negotiate internet bill terms for future reference",
    "Professional consultation to lower internet bill costs"
  ];

  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-white mb-4">Real NYC Business Internet Savings</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            See how businesses across NYC and Hudson Valley have reduced their internet costs with our professional negotiation services. 
            Many were surprised to learn they were paying well above the average internet bill NYC businesses should expect.
          </p>
        </motion.div>

        {/* Testimonials */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,y: 50}}
              whileInView={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: index * 0.2}}
              className="bg-gray-900 p-6 rounded-xl border border-gray-700"
            >
              <div className="text-center mb-4">
                <div className="bg-gradient-to-r from-red-500 to-blue-500 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                  <SafeIcon icon={FiDollarSign} className="text-xl text-white" />
                </div>
                <h3 className="text-lg font-semibold text-white">{testimonial.business}</h3>
                <p className="text-gray-400 text-sm">{testimonial.provider}</p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg mb-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-400">Before:</span>
                  <span className="text-red-400 font-semibold">{testimonial.oldBill}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-400">After:</span>
                  <span className="text-green-400 font-semibold">{testimonial.newBill}</span>
                </div>
                <div className="flex justify-between items-center border-t border-gray-700 pt-2">
                  <span className="text-white font-semibold">Monthly Savings:</span>
                  <span className="text-blue-400 font-bold">{testimonial.savings}</span>
                </div>
              </div>
              <p className="text-gray-300 italic text-sm">"{testimonial.quote}"</p>
            </motion.div>
          ))}
        </div>

        {/* Transparency Disclaimer */}
        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="bg-yellow-900/20 border border-yellow-600 rounded-xl p-6 mb-8"
        >
          <p className="text-yellow-200 text-sm leading-relaxed text-center">
            <strong className="text-yellow-400">Please note:</strong> Not all customers will qualify for price reductions. Eligibility may be affected by existing contracts, current promotional pricing, Dedicated Internet Access (DIA) plans, or if you're already receiving the best available rate from your provider.
          </p>
        </motion.div>

        {/* Benefits */}
        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="bg-gray-900 p-8 rounded-xl border border-gray-700"
        >
          <h3 className="text-2xl font-bold text-white mb-6 text-center">Why Choose Our NYC Business Internet Service</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {benefits.map((benefit,index)=> (
              <div key={index} className="flex items-center gap-3">
                <SafeIcon icon={FiCheck} className="text-green-400 text-xl flex-shrink-0" />
                <span className="text-gray-300">{benefit}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RealSavings;